
const digest = '17cbc4a8c462b391f277facd87cf2053954c70c05ce1b97f6432212684414243';
const classes = {"wrapper":"_wrapper_r6pi1_1"};
const css = `._wrapper_r6pi1_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  padding: 24px;
  gap: 30px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  